module.exports = __webpack_public_path__ + "img/brand4.c11a73bb.png";